<div class="container-fluid">
  <div class="row pt-4 pl-4" style="font-size: 22px !important;
  font-weight: 400;
  color: #424242;">
    <h5><i class="fa fa-circle" style="color:#800000"></i> &nbsp;Annual Salary Report</h5>
  </div>
<div id="mainContent" class="container">
 <div class="modal-body">
  <div class="row">
    <div class="col-sm-6">
      <div class="row">
        <label class="col-sm-4 col-form-label"
          >Financial Year<span class="text-danger">*</span></label>
        <div class="col-sm-6">
          <select
            class="form-control form-control-xs mt-1"
            [(ngModel)]="selectedFinancialYear"
            (change)="onFinancialYearSelected()"
          >
            <option value="">Select Year</option>
            <option *ngFor="let finance of financialList" [ngValue]="finance">
              {{ finance.name }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <div class="col-sm-6">
      <div class="row">
        <label class="col-sm-4 col-form-label"
          >Branch<span class="text-danger">*</span></label
        >
        <div class="col-sm-6">
          <select
            class="form-control form-control-xs mt-1"
            [(ngModel)]="selectedBranch"
            (change)="onBranchSelected()"
          >
            <option value="">Select Branch</option>
            <option *ngFor="let branch of branchList" [ngValue]="branch">
              {{ branch.name }}
            </option>
          </select>
        </div>
      </div>
    </div>
  </div>
    <div class="row">
      <div class="col-sm-6">
        <div class="row">
          <label class="col-sm-4 col-form-label"
            >Partner<span class="text-danger">*</span></label
          >
          <div class="col-sm-6">
            <!-- <select
              class="form-control form-control-xs mt-1"
              [(ngModel)]="selectedPartner"
              (change)="onPartnerSelected()"
            >
              <option value="">Select Partner</option>
              <option *ngFor="let partner of partnerList" [ngValue]="partner">
                {{ partner.firstName }}{{ partner.lastName }}
              </option>
            </select> -->
            <mat-form-field appearance="legacy" style="width: 100%">
              <mat-select
                multiple
                [(ngModel)]="selectedPartner"
                #designatePartner="ngModel"
              >
                <mat-option
                  (click)="selectAllPartner(designatePartner, partnerList)"
                  [value]="0"
                  >Select All
                </mat-option>
                <mat-option
                  (click)="onPartnerSelected()"
                  #item
                  *ngFor="let partner of partnerList"
                  [value]="partner"
                >
                  {{ partner.firstName }} {{ partner.middleName }}
                  {{ partner.lastName }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="col-sm-6">
        <div class="row">
          <label class="col-sm-4 col-form-label"
            >Role<span class="text-danger">*</span></label
          >
          <div class="col-sm-6">
            <mat-form-field appearance="legacy" style="width: 100%">
              <mat-select
                multiple
                [(ngModel)]="selectedRole"
                #designateRole="ngModel"
              >
                <mat-option
                  (click)="selectAllRole(designateRole, roleList)"
                  [value]="0"
                  >Select All
                </mat-option>
                <mat-option
                (click)="onRoleSelected()"
                  #item
                  *ngFor="let role of roleList"
                  [value]="role"
                >
                  {{ role.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-sm-6">
        <div class="row">
          <label class="col-sm-4 col-form-label"
            >From Closing Date<span class="text-danger">*</span></label
          >
          <div class="col-sm-6">
            <select
              class="form-control form-control-xs mt-1"
              [(ngModel)]="selectedFromClosing"
            >
              <option value="">Select From Date</option>
              <option
                *ngFor="let closing of closingDateList"
                [ngValue]="closing"
              >
                {{ closing.closingDate }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="row">
          <label class="col-sm-4 col-form-label"
            >To Closing Date<span class="text-danger">*</span></label
          >
          <div class="col-sm-6">
            <select
              class="form-control form-control-xs mt-1"
              [(ngModel)]="selectedToClosing"
            >
              <option value="">Select To Date</option>
              <option
                *ngFor="let closing of closingDateList"
                [ngValue]="closing"
              >
                {{ closing.closingDate }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-sm-6">
        <div class="row">
          <label class="col-sm-4 col-form-label"
            >Employee Name<span class="text-danger">*</span></label
          >
          <div class="col-sm-6">
            <mat-form-field appearance="legacy" style="width: 100%">
              <mat-select
                multiple
                [(ngModel)]="selectedEmployeeName"
                #designateEmployeeName="ngModel"
              >
                <mat-option
                  (click)="
                    selectAllEmployee(designateEmployeeName, employeeList)
                  "
                  [value]="0"
                  >Select All
                </mat-option>
                <mat-option
                  #item
                  *ngFor="let employee of employeeList"
                  [value]="employee"
                >
                  {{ employee.firstName }} {{employee.middleName}} {{employee.lastName}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div> 

      <div class="col-sm-2">
        <button
          type="button"
          class="btn btn-sm btn-block btn-outline-theme"
          (click)="onViewReport()"
        >
          View Report
        </button>
      </div>
      <div class="col-sm-2" *ngIf="showExportToExcelButton">
        <button
          type="button"
          class="btn btn-sm btn-block btn-outline-theme"
          (click)="onExportToExcelReport()"
        >
          Export To Excel
        </button>
      </div>
    </div>
    </div>
    </div>

    <div class="container pt-3" id="mainContent" *ngIf="annualSalaryReportList.length>0">
      <div class="row justify-content-center text-center">
        <span class="bg-theme-title"
          >P G BHAGWAT LLP, Chartered Accountants
        </span>
      </div>
      <div class="row justify-content-center text-center ">
        <span>Suite 102, "Orchard", Dr Pai Marg, Baner, Pune - 411045 </span>
      </div>
      <div class="row col-md-12 mt-3">
        <table class="table table-bordered table-sm" style="display: block; overflow-x: auto; white-space: nowrap">
          <thead>
            <tr>
              <th>Id</th>
              <th>Name</th>
              <th>Partner Name</th>
              <!-- <th>Month</th> -->
              <th>CTC</th>
              <th>Basic salary</th>
              <th>Conveyance Allowance</th>
              <th>HRA Allowance</th>
              <th>Mobile Allowance</th>
              <th>Other Allowance</th>
              <th>Educational allowance</th>
              <th>Child education allowance</th>
              <th>Reimbursement of Conveyance</th>
              <th>OT</th>
              <th>Leave Encashment</th>
              <th>Travel allowance</th>
              <!-- <th>Other</th> -->
              <th>Security Deposit</th>
              <th>Professional tax</th>
              <th>PF</th>
              <th>TDS</th>
              <th>Penalty</th>
              <th>Leave amount</th>
              <th>Bonus</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody *ngFor="let data of annualSalaryReportList;let i=index;">
            <td>{{i+1}}</td>
            <td>{{data.firstName}} {{data.middleName}} {{data.lastName}}</td>
            <td>{{data.partner_fname}} {{data.partner_lname}}</td>
            <!-- <td>{{data.monthName}}</td> -->
            <td>{{data.ctc}}</td>
            <td>{{data.basicSalary}}</td>
            <td>{{data.conveyanceAllowance}}</td>
            <td>{{data.hraAllowance}}</td>
            <td>{{data.mobileAllowance}}</td>
            <td>{{data.otherAllowances}}</td>
            <td>{{data.educationalAllowance}}</td>
            <td>{{data.childHostelAllowance}}</td>
            <td>{{data.reimbursementOfConveyance}}</td>
            <td>{{data.overtime}}</td>
            <td>{{data.leaveEncashment}}</td>
            <td>{{data.travellingAllowance}}</td>
            <!-- <td>{{data.other}}</td> -->
            <td>{{data.securityDeposit}}</td>
            <td>{{data.professionalTax}}</td>
            <td>{{data.providentFund}}</td>
            <td>{{data.tds}}</td>
            <td>{{data.penalty}}</td>
            <td>{{data.leaves}}</td>
            <td>{{data.bonus}}</td>
            <td>{{data.netSalary}}</td>
          </tbody>
          <tfoot style="background-color: #87cefa;">
            <tr>
              <td>Total</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>{{calculateAllTotal }}</td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </div>

